import { authRoles } from 'app/auth';
import ProfileEditForm from './editform/ProfileEditForm';
import ProfileTable from './table/ProfileTable';

export default [
	{
		path: '/profile/edit/:id',
		component: ProfileEditForm,
		auth: authRoles.userAccount
	},
	{
		path: '/profile/:sessionNameParam?',
		component: ProfileTable,
		auth: authRoles.userAccount
	}
];
